import React from "react";
import { Star, TrendingUp, Loader2 } from "lucide-react";
import { usePrefersReducedMotion } from "../hooks/usePrefersReducedMotion";

const LoadingSpinner = () => {
    const prefersReducedMotion = usePrefersReducedMotion();

    return (
        <div className="flex flex-col justify-center items-center min-h-screen bg-background">
            {/* Brand Logo */}
            <div className="flex items-center gap-2 mb-6">
                <Star className="h-8 w-8 text-secondary-readable fill-current" />
                <h1 className="text-h2 font-bold tracking-tight text-foreground font-semibold">
                    PremiereLens
                </h1>
                <TrendingUp className="h-8 w-8 text-primary" />
            </div>

            {/* Loading Animation */}
            <div className="relative">
                <Loader2 className={`h-16 w-16 text-primary ${prefersReducedMotion ? "" : "animate-spin"}`} />
                {!prefersReducedMotion && (
                    <div className="absolute inset-0 h-16 w-16 rounded-full border-2 border-primary/20 animate-ping opacity-20"></div>
                )}
            </div>

            {/* Loading Message */}
            <div className="mt-6 text-center">
                <p className="text-body-large font-medium mb-2 text-foreground font-semibold">
                    Loading the shows
                </p>
                <p className="text-body-small text-muted-foreground">
                    Finding shows worth your time...
                </p>
            </div>

            {/* Loading Steps */}
            <div className="mt-8 flex flex-col sm:flex-row gap-4 text-body-xs">
                <div className="flex items-center gap-2 px-3 py-2 rounded-full bg-muted/50">
                    <div className={`h-2 w-2 bg-primary rounded-full ${prefersReducedMotion ? "" : "animate-pulse"}`}></div>
                    <span className="text-muted-foreground">
                        Fetching releases
                    </span>
                </div>
                <div className="flex items-center gap-2 px-3 py-2 rounded-full bg-muted/50">
                    <div className={`h-2 w-2 bg-secondary rounded-full ${prefersReducedMotion ? "" : "animate-pulse animation-delay-300"}`}></div>
                    <span className="text-muted-foreground">
                        Applying quality filters
                    </span>
                </div>
                <div className="flex items-center gap-2 px-3 py-2 rounded-full bg-muted/50">
                    <div className={`h-2 w-2 bg-primary rounded-full ${prefersReducedMotion ? "" : "animate-pulse animation-delay-700"}`}></div>
                    <span className="text-muted-foreground">
                        Organising results
                    </span>
                </div>
            </div>
        </div>
    );
};

export default LoadingSpinner;
